import {
  linkMatchesActivityTypeId,
  linkMatchesStudyProgramInFilter,
  studyProgramMatchesAreaOfInterest,
  studyProgramMatchesId,
  studyProgramMatchesLanguage,
} from "@/views/components/filters/filter-functions";
import {
  PublicActivityRegistrationLinkDTO,
  PublicStudyProgramDto,
} from "lib/eduConfigurationServiceClient";

export function filterLinksByQueryParams(
  links: PublicActivityRegistrationLinkDTO[],
  studyPrograms: PublicStudyProgramDto[],
  params: {
    activityTypeId?: string;
    areaOfInterestId?: string;
    studyProgramLanguage?: string;
    studyProgramId?: string;
  },
) {
  const filteredStudyPrograms = filterStudyProgramsByQueryParams(
    studyPrograms,
    params,
  );

  return links
    .filter(linkMatchesActivityTypeId(params.activityTypeId))
    .filter(linkMatchesStudyProgramInFilter(filteredStudyPrograms));
}

export function filterStudyProgramsByQueryParams(
  studyPrograms: PublicStudyProgramDto[],
  params: {
    studyProgramId?: string;
    areaOfInterestId?: string;
    studyProgramLanguage?: string;
  },
) {
  // When no studyprograms or no params, we should totally ignore
  // the study program filter, because some links are not associated
  // with any study program and we don't want to filter them out
  // by default
  if (studyPrograms.length === 0) {
    return undefined;
  }
  if (
    !params.studyProgramId &&
    !params.areaOfInterestId &&
    !params.studyProgramLanguage
  ) {
    return undefined;
  }

  return studyPrograms
    .filter(studyProgramMatchesId(params.studyProgramId))
    .filter(studyProgramMatchesAreaOfInterest(params.areaOfInterestId))
    .filter(studyProgramMatchesLanguage(params.studyProgramLanguage));
}
